import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Insights', path: '/insights' },
    { name: 'Impact', path: '/impact' },
    { name: 'Resilience', path: '/quiz' },
    { name: 'Collaborate', path: '/collaborate' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Indigenous Acknowledgement Banner */}
      <div className="bg-kabi-teal text-ozone-white py-2 px-4 text-center text-sm" data-testid="indigenous-acknowledgement-banner">
        <p className="font-medium">Always was, always will be. We acknowledge the Kabi Kabi people as Traditional Custodians of the Sunshine Coast.</p>
      </div>

      {/* Main Navigation */}
      <nav className="bg-ozone-white border-b border-basalt-carbon/10 sticky top-0 z-50" data-testid="main-navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
              <div className="text-2xl font-bold text-kabi-teal">SUSTAINIFY<sup className="text-sm">®</sup></div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.name.toLowerCase()}`}
                  className={`text-sm font-medium tracking-wide transition-colors ${
                    isActive(link.path)
                      ? 'text-kabi-teal border-b-2 border-kabi-teal'
                      : 'text-basalt-carbon hover:text-kabi-teal'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="mailto:info@sustainify.com.au"
                data-testid="cta-button"
                className="bg-solar-kinetic text-basalt-carbon px-6 py-2 rounded-full font-semibold hover:bg-solar-kinetic/90 transition-colors"
              >
                Get Started
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden text-basalt-carbon"
              data-testid="mobile-menu-button"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isOpen && (
            <div className="md:hidden py-4 border-t border-basalt-carbon/10" data-testid="mobile-menu">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`block py-3 text-sm font-medium ${
                    isActive(link.path) ? 'text-kabi-teal' : 'text-basalt-carbon'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="mailto:info@sustainify.com.au"
                className="block mt-4 bg-solar-kinetic text-basalt-carbon px-6 py-2 rounded-full font-semibold text-center"
              >
                Get Started
              </a>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;